/**
 * Application-wide permission constants.
 * Format: 'resource:action'
 *
 * Import from @constants/permissions — never hard-code permission strings.
 */

export const PERMISSIONS = {
  // Dashboard
  DASHBOARD_VIEW:   'dashboard:view',
  DASHBOARD_MANAGE: 'dashboard:manage',

  // Users
  USERS_CREATE: 'users:create',
  USERS_READ:   'users:read',
  USERS_UPDATE: 'users:update',
  USERS_DELETE: 'users:delete',
  USERS_EXPORT: 'users:export',
  USERS_MANAGE: 'users:manage',

  // Events
  EVENTS_CREATE: 'events:create',
  EVENTS_READ:   'events:read',
  EVENTS_UPDATE: 'events:update',
  EVENTS_DELETE: 'events:delete',
  EVENTS_EXPORT: 'events:export',
  EVENTS_MANAGE: 'events:manage',

  // Assignments
  ASSIGNMENTS_CREATE: 'assignments:create',
  ASSIGNMENTS_READ:   'assignments:read',
  ASSIGNMENTS_UPDATE: 'assignments:update',
  ASSIGNMENTS_DELETE: 'assignments:delete',
  ASSIGNMENTS_MANAGE: 'assignments:manage',

  // Connections
  CONNECTIONS_CREATE:       'connections:create',
  CONNECTIONS_READ:         'connections:read',
  CONNECTIONS_UPDATE:       'connections:update',
  CONNECTIONS_DELETE:       'connections:delete',
  CONNECTIONS_EXPORT:       'connections:export',
  CONNECTIONS_VIEW_REPORTS: 'connections:view_reports',
  CONNECTIONS_MANAGE:       'connections:manage',

  // Reports
  REPORTS_READ:   'reports:read',
  REPORTS_EXPORT: 'reports:export',
  REPORTS_MANAGE: 'reports:manage',

  // Notifications
  NOTIFICATIONS_CREATE: 'notifications:create',
  NOTIFICATIONS_READ:   'notifications:read',
  NOTIFICATIONS_UPDATE: 'notifications:update',
  NOTIFICATIONS_DELETE: 'notifications:delete',
  NOTIFICATIONS_MANAGE: 'notifications:manage',

  // Email Templates
  EMAIL_TEMPLATES_CREATE: 'email_templates:create',
  EMAIL_TEMPLATES_READ:   'email_templates:read',
  EMAIL_TEMPLATES_UPDATE: 'email_templates:update',
  EMAIL_TEMPLATES_DELETE: 'email_templates:delete',

  // Settings
  SETTINGS_VIEW:   'settings:view',
  SETTINGS_UPDATE: 'settings:update',
  SETTINGS_MANAGE: 'settings:manage',

  // Roles & Permissions
  ROLES_CREATE: 'roles:create',
  ROLES_READ:   'roles:read',
  ROLES_UPDATE: 'roles:update',
  ROLES_DELETE: 'roles:delete',
  ROLES_MANAGE: 'roles:manage',

  // Companies (Super Admin)
  COMPANIES_CREATE: 'companies:create',
  COMPANIES_READ:   'companies:read',
  COMPANIES_UPDATE: 'companies:update',
  COMPANIES_DELETE: 'companies:delete',
  COMPANIES_MANAGE: 'companies:manage',
}

export const ALL_PERMISSIONS = Object.values(PERMISSIONS)

// Roles that have access to the /admin/* console
export const ADMIN_ROLES = ['super_admin', 'admin']
